import React from 'react';
import { useFocusable } from '@/hooks/useFocusable';
import { SearchIcon } from '@/components/svg';
import styles from './Header.module.scss';

interface FocusableSearchButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  focusKey: string;
  onClick?: () => void;
  onFocusChange?: () => void;
  onArrowPress?: (direction: string) => boolean;
  className?: string;
  iconClassName?: string;
}

export const FocusableSearchButton: React.FC<FocusableSearchButtonProps> = ({
  focusKey,
  onClick,
  onFocusChange,
  onArrowPress,
  className = '',
  iconClassName = '',
  ...rest
}) => {
  const { ref, focused } = useFocusable({
    focusKey,
    onEnterPress: onClick,
    onFocus: () => {
      onFocusChange?.();
    },
    onArrowPress: (...args) => {
      // 如果没有提供 onArrowPress 回调，默认返回 true（允许导航）
      // 如果提供了回调，使用回调的返回值（false = 阻止导航，true = 允许导航）
      return onArrowPress ? onArrowPress(...args) : true;
    },
  });

  return (
    <button
      ref={ref}
      className={`${className} ${focused ? styles.searchButtonFocused : ''}`}
      onClick={onClick}
      {...rest}
    >
      <SearchIcon className={iconClassName} />
    </button>
  );
};
